import { Link } from "react-router-dom";
import { cn } from "@/lib/utils";

interface WormbleLogoProps {
  linkTo?: string | null;
  size?: "sm" | "md" | "lg";
  className?: string;
  onClick?: () => void;
}

const sizeClasses = {
  sm: "text-lg sm:text-xl",
  md: "text-2xl",
  lg: "text-5xl md:text-6xl"
};

export function WormbleLogo({ linkTo = "/", size = "md", className, onClick }: WormbleLogoProps) {
  const logoContent = (
    <>
      <span className="text-primary">W</span>
      <span className="text-tile-correct">o</span>
      <span className="text-tile-present">r</span>
      <span className="text-accent-foreground">m</span>
      <span className="text-destructive">b</span>
      <span className="text-muted-foreground">l</span>
      <span className="text-secondary-foreground">e</span>
    </>
  );

  const baseClasses = cn(
    "font-bold tracking-tight",
    sizeClasses[size],
    className
  );

  if (linkTo === null) {
    return (
      <span className={baseClasses} onClick={onClick} data-wormble-logo>
        {logoContent}
      </span>
    );
  }

  return (
    <Link 
      to={linkTo} 
      className={cn(baseClasses, "hover:opacity-80 transition-opacity")}
      onClick={onClick}
      data-wormble-logo
      data-logo-link
    >
      {logoContent}
    </Link>
  );
}
